// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jP2Z","label":"styles_label__1r6EI"};